import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/base-classes/componet-base';
import { ActivatedRoute } from '@angular/router';
import { switchMap, map } from 'rxjs/operators';
import { OnlineExamSchedule } from '../../../dashboard/models/online-exam-schedule';
import { Student } from 'src/app/models/student';
import { ExamTestService } from '../../../exams/services/exam-test.service';
import { Subject, timer } from 'rxjs';
import { UserService } from 'src/app/services/user/user-service/user.service';
import { UserContext } from 'src/app/models/user-context';
import { LocalStorageService } from 'src/app/services/local-storage-service/local-storage.service';
import { AppSettings } from 'src/app/utils/app-settings';
import { WardsService } from 'src/app/services/wards-service/wards.service';
import { PrifactRoute } from 'src/app/models/prifact-route';
import { RoutingService } from 'src/app/services/routing-service/routing.service';
import { AttemptService } from '../../../exams/services/attempt.service';

@Component({
  selector: 'app-online-exam-start',
  templateUrl: './online-exam-start.component.html',
  styleUrls: ['./online-exam-start.component.scss']
})
export class OnlineExamStartComponent extends ComponentBase implements OnInit {

  constructor(private route: ActivatedRoute
    , private examTestService: ExamTestService
    , private userService: UserService
    , private localStorageService: LocalStorageService
    , private wardsService: WardsService
    , private routingService: RoutingService
    , private attemptService: AttemptService) { super(); }

  selectedExamTest: OnlineExamSchedule;
  studentInfo: Student;
  loading: boolean = true;
  isStartDisabled: boolean = true;
  hours: string;
  minutes: string;
  seconds: string;
  private dateSubject = new Subject<string>();
  serverTime: string;
  timeDiff: number;
  errors: Error[] = [];
  isExamOver: boolean = false;

  ngOnInit() {
    let sub1 = this.route.params.pipe(
      switchMap(params => {
        return this.examTestService.getExamTestById(params['id']);
      })
    ).subscribe(res => {
      this.loading = false;
      if (res.body) {
        this.selectedExamTest = res.body;
        this.dateSubject.next(res.headers.get('date'));
      }
      else {
        this.redirectToDashboard();
      }
    })
    this.addSubscription(sub1);

    let sub2 = this.userService.getLoggedInUser()
      .subscribe(user => {
        this.loading = false;
        if (!user.students || user.students.length == 0) {
          window.location.href = "/";
          return;
        }
        let user_context: UserContext = this.localStorageService.getItem(AppSettings.LocalStorageUserContextKey);
        if (!user_context) {
          window.location.href = "/";
          return;
        }
        if (user_context && user.person.person_id == user_context.person_id) {
          this.studentInfo = user.students.find(o => o.student_id == user_context.student_id);
        }
        if (!this.studentInfo) {
          window.location.href = "/";
          return;
        }
        else {
          this.wardsService.setWard(this.studentInfo);
        }
      });
    this.addSubscription(sub2);

    let sub3 = this.dateSubject.pipe(
      switchMap(res => {
        this.serverTime = res;
        this.timeDiff = new Date(this.selectedExamTest.from_time).getTime() - new Date(this.serverTime).getTime();
        return timer(0, 1000)
      })
    ).subscribe(res => {
      let timeleft = this.timeDiff - (res * 1000);

      let hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

      this.hours = hours + "h "
      this.minutes = minutes + "m "
      this.seconds = seconds + "s "
      if (timeleft < 0) {
        sub3.unsubscribe();
        this.isStartDisabled = false;
        this.showTimeLeft();
      }
    });
    this.addSubscription(sub3);
  }

  showTimeLeft(){
    if(new Date(this.serverTime).getTime() >= new Date(this.selectedExamTest.from_time).getTime()) {
      this.timeDiff = new Date(this.selectedExamTest.to_time).getTime() - new Date(this.serverTime).getTime();
    }
    else {
      this.timeDiff = new Date(this.selectedExamTest.to_time).getTime() - new Date(this.selectedExamTest.from_time).getTime();
    }
    let sub = timer(0, 1000).subscribe(res => {
      let timeleft = this.timeDiff - (res * 1000);

      let hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

      this.hours = hours + "h "
      this.minutes = minutes + "m "
      this.seconds = seconds + "s "
      if (timeleft < 0) {
        this.isExamOver = true;
        sub.unsubscribe(); 
      }
    });
    this.addSubscription(sub);
  }

  onStart() {
    this.errors = [];
    let sub = this.attemptService.attemptTest(this.selectedExamTest.examination_test_id)
    .subscribe(res => {
      let route = new PrifactRoute();
      route.primary_command = ['online-exam', this.selectedExamTest.examination_test_id, 'attempt', res.attempt_id];
      route.append_current_url_to_history = true;
      this.routingService.navigate(route);
    }, err => {
      this.errors.push({"name":err.code,"message":err.message});
    });
    this.addSubscription(sub);
  }

  redirectToDashboard() {
    let route = new PrifactRoute();
    route.url = "/pages/dashboard";
    route.clear_history = true;
    this.routingService.navigate(route);
  }


}
